import { useAuth } from "@clerk/clerk-react";
import { AlertContext } from "contexts/Alert";
import { OrganizationUserContext } from "contexts/Organization";
import { OutreachTemplatesContext } from "contexts/OutreachTemplates";
import { useCallback, useContext } from "react";

import { Template } from "features/Influencer/ContactList/schema";
import { fetcherAuth } from "utils/api";

/** Validates the name, creates a copy template, appends it to the list, and returns it (null if invalid). */
export function useSaveAsNewTemplate() {
  const { getToken } = useAuth();
  const { currentOrg } = useContext(OrganizationUserContext);
  const { templates, setTemplates } = useContext(OutreachTemplatesContext);
  const { setAlert } = useContext(AlertContext);

  return useCallback(
    async (
      template: Template,
      newName: string,
      extra?: Record<string, unknown>,
    ): Promise<Template | null> => {
      const name = newName.trim();
      if (!name) {
        setAlert("Please enter a template name", "error");
        return null;
      }
      if (
        templates.find(
          (t) => t.name === name && t.contentType === template.contentType,
        )
      ) {
        setAlert("You already have a template with the same name", "error");
        return null;
      }
      if (!currentOrg?.id) return null;
      const res = await fetcherAuth(
        getToken,
        `/api/organization/${currentOrg.id}/templates`,
        "POST",
        {},
        { ...template, ...extra, id: undefined, name },
      );
      setTemplates((prev) => [...prev, res.template]);
      return res.template;
    },
    [getToken, currentOrg?.id, templates, setTemplates, setAlert],
  );
}
